import { defineStore } from 'pinia';
import { computed } from 'vue';
import { useStore } from 'vuex';

import GlobalRequest from '../../../../../api/global-request';
import { showToast } from '../../../../../helpers/toast-handler';

const DATASOURCE_METRIC_URL = 'v2/datasource/metric';
const DATASOURCE_USER_GROUP_URL = 'v2/datasource/users';

export const useStaticDashboardStore = defineStore('staticDashboard', () => {
    const store = useStore();
    const company_id = computed(() => {
        return store.getters['auth/userCompanyId']?.id;
    });
    // states

    // actions
    const getMetricDataById = async (metricId) => {
        try {
            const response = await GlobalRequest.getRequest(`${DATASOURCE_METRIC_URL}/${metricId}?company_id=${company_id.value}`);
            return response.data;
        } catch (error) {
            showToast(error.response, 'Error loading metric data for id:', metricId);
        }
    };

    const getUserGroupData = async (userGroupId) => {
        try {
            const response = await GlobalRequest.getRequest(`${DATASOURCE_USER_GROUP_URL}/${userGroupId}/display?company_id=${company_id.value}`);
            return response.data;
        } catch (error) {
            showToast(error.response, 'Error loading usergroup data for id:', userGroupId);
            throw error;
        }
    };
    return {
        // states
        // actions
        getMetricDataById,
        getUserGroupData,
        // helpers
    };
});
